<template>
  <b-collapse id="nav-collapse" is-nav class="mr-2" style="flex:0">
    <b-navbar-nav>
      <b-nav-item-dropdown right no-caret>
        <template slot="button-content">
            <span class="text-white">
              <font-awesome-icon icon="bell"/>
              <span class="badge badge-danger badge-pill notification-count" v-if="notificationsCount > 0">
                {{notificationsCount}}
              </span>
            </span>
        </template>
        <b-dropdown-group id="dropdown-group-1" header="Notifications">
          <b-dropdown-item-button v-for="notification in notifications">
            <font-awesome-icon :icon="notification.icon" class="mr-2" :class="notification.iconClass"/>
            {{notification.display_name}}
          </b-dropdown-item-button>
        </b-dropdown-group>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </b-collapse>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";

  const {mapState} = createNamespacedHelpers('global');

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "NavbarNotifications",
    computed: {
      ...mapState({
        notifications: state => state.notifications,
      }),
      notificationsCount() {
        return this.notifications.reduce((a, b) => a + b.count, 0)
      }
    },
  }
</script>

<style lang="scss" scoped>
  .notification-count {
    position: absolute;
    top: 7px;
    right: -7px;
  }
</style>
